import { render, staticRenderFns } from "./StudyQuestionVertical.vue?vue&type=template&id=1a6fcb6c&scoped=true&lang=pug"
import script from "./StudyQuestionVertical.vue?vue&type=script&lang=ts"
export * from "./StudyQuestionVertical.vue?vue&type=script&lang=ts"
import style0 from "./StudyQuestionVertical.vue?vue&type=style&index=0&id=1a6fcb6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fcb6c",
  null
  
)

export default component.exports